import React from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { Link, withRouter } from 'react-router-dom';
import { translate, getUserNameToName, formatData } from '../../../utils/util';
import ConfigurationService from '../../../services/ConfigurationService';
import { Input } from '../../../components/UI/ComponentsUI'

const ResourceListItem = (props) => {
    return (
        <>
            <span
                className="title sixth-text-color right"
                style={{ position: 'absolute', right: '15px', marginTop: '5px' }}
            >
                <i onClick={() => props.onDelete(props.data?.resourceId)} className="material-icons sixth-text-color" style={{ fontSize: '1.75rem', cursor: 'pointer' }}>delete</i>
                <Input
                    type="checkbox"
                    onChange={() => props.onCheckItem(props.data)}
                    id="select"
                    name="select"
                />
            </span>
            <Link
                style={{ display: 'block' }}
                to={props.route}
                onClick={(event) => {
                    if (props.onSelectChange) {
                        props.onSelectChange(event);
                    }
                }}
            >
                <span className="title sixth-text-color">
                    <i className="mdi mdi-text-box-check-outline" /> {props.data.name}
                </span>
                <span className="truncate second-text-color" style={{ marginLeft: '10px' }}>
                    <i className="mdi mdi-text-box-check-outline" /> {props.data.active ? translate("configuration:menu.active") : translate("configuration:menu.unactive")}
                </span>

                <span className="truncate second-text-color" style={{ marginLeft: '10px' }}>
                    <i className="mdi mdi-history" /> {formatData(props.data?.updateOn)}
                </span>
                <span className="truncate second-text-color" style={{ marginLeft: '10px' }}>
                    <i className="mdi mdi-account" /> {props.data.updateBy} - {getUserNameToName(props?.usersFromElog, props.data.updateBy)}
                </span>
            </Link>
        </>
    );
};
const mapStateToProps = (state) => {
    return {
        usersFromElog: state.usersElogReducer.usersElog
    };
}

const mapDispatchToProps = (dispatch) => {
    return {
        deleteResource: (resourceId, callback) => {
            dispatch(ConfigurationService.deleteResource(resourceId, callback));
        },
    };
};


export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withTranslation()(ResourceListItem)));